//export const API_DOMAIN = 'https://ticketevent.deaninfo.com/';
export const API_DOMAIN = 'https://www.simatours.myticketshop.be/backend/public/';
// https://www.simatours.myticketshop.be/backend/public is automatically coming from package.json file look for proxy at the end of file
//export const API_DOMAIN = '/backend/public/';
export const IMAGE_BASE_URL = 'https://www.simatours.myticketshop.be/backend/public/storage';
